module.exports = {"backCopy":"Voltar para resumo","backCopyDados":"Voltar para dados do plano"}


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/TemplateRecharge/data.json
// module id = 1841
// module chunks = 0